import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { DeviceType } from 'src/common/enumerations/device-type';
import { IDeviceStatusState } from 'src/common/interfaces/states/IDeviceStatusState';
import { IDeviceStatusItem } from '../../interfaces/states/IDeviceStatusItem';

export const initialState: IDeviceStatusState = {
  devices: [],
  hasCustomerDisplay: false,
};

class DeviceStatusReducer extends ImmerReducer<IDeviceStatusState> {
  public setDevices(devices: IDeviceStatusItem[]) {
    devices = devices.filter(device => device.deviceType !== DeviceType.CustomerDisplay);
    this.draftState.devices = devices;
  }

  public clearDevices() {
    this.draftState = initialState;
  }

  public addDevice(device: IDeviceStatusItem) {
    if (device) {
      this.draftState.devices = [...this.draftState.devices, device];
    }
  }

  public updateDevice(device: Partial<IDeviceStatusItem>) {
    const index = this.draftState.devices.findIndex(
      item => item.logicalName === device.logicalName,
    );
    if (index !== -1) {
      this.draftState.devices[index] = { ...this.draftState.devices[index], ...device };
    }
  }

  public updateCustomerDisplay(status: boolean) {
    this.draftState.hasCustomerDisplay = status;
  }
}

export const DeviceStatusActions = createActionCreators(DeviceStatusReducer);
export const DeviceStatusReducerFunction = createReducerFunction(DeviceStatusReducer, initialState);
